export interface DocPage {
  title: string;
  path: string;
  file: string;
  children?: DocPage[];
}

export interface DocSection {
  title: string;
  pages: DocPage[];
}

export const docsManifest: DocSection[] = [
  {
    title: "Getting Started",
    pages: [
      { title: "Introduction", path: "", file: "README.md" },
      {
        title: "Client Onboarding",
        path: "client-onboarding",
        file: "client-onboarding.md",
      },
    ],
  },
  {
    title: "Trade Proposal System",
    pages: [
      {
        title: "Overview",
        path: "trade-proposal/overview",
        file: "trade-proposal/overview.md",
      },
      {
        title: "Proposal Steps",
        path: "trade-proposal/proposal-steps",
        file: "trade-proposal/proposal-steps.md",
      },
      {
        title: "Models",
        path: "trade-proposal/models",
        file: "trade-proposal/models.md",
      },
      {
        title: "Model Assignment",
        path: "trade-proposal/11-model-assignment",
        file: "trade-proposal/11-model-assignment.md",
        children: [
          {
            title: "Completion Strategy",
            path: "trade-proposal/11b-completion-strategy",
            file: "trade-proposal/11b-completion-strategy.md",
          },
          {
            title: "Soft-Completion Strategy",
            path: "trade-proposal/11c-soft-completion",
            file: "trade-proposal/11c-soft-completion.md",
          },
        ],
      },
      {
        title: "Cash Adjusted Target",
        path: "trade-proposal/12-cash-adjusted",
        file: "trade-proposal/12-cash-adjusted.md",
      },
      {
        title: "Security Restrictions",
        path: "trade-proposal/13-security-restrictions",
        file: "trade-proposal/13-security-restrictions.md",
      },
      {
        title: "Secondary Securities",
        path: "trade-proposal/21-secondary-securities",
        file: "trade-proposal/21-secondary-securities.md",
      },
      {
        title: "Tax Constraints",
        path: "trade-proposal/22-tax-constraints",
        file: "trade-proposal/22-tax-constraints.md",
      },
      {
        title: "Constrained Allocation",
        path: "trade-proposal/23-constrained-allocation",
        file: "trade-proposal/23-constrained-allocation.md",
      },
      {
        title: "Trade Generation",
        path: "trade-proposal/24-trade-generation",
        file: "trade-proposal/24-trade-generation.md",
      },
      {
        title: "Cash Management",
        path: "trade-proposal/cash-management",
        file: "trade-proposal/cash-management.md",
      },
      {
        title: "Tax Loss Harvesting",
        path: "trade-proposal/tlh",
        file: "trade-proposal/tlh.md",
      },
    ],
  },
  {
    title: "Billing",
    pages: [
      {
        title: "Overview",
        path: "billing/overview",
        file: "billing/overview.md",
      },
      {
        title: "Billing Steps",
        path: "billing/billing-steps",
        file: "billing/billing-steps.md",
      },
      {
        title: "Fee Structures",
        path: "billing/fee-structures",
        file: "billing/fee-structures.md",
      },
      {
        title: "Flat Group Fee",
        path: "billing/flat-group-fee",
        file: "billing/flat-group-fee.md",
      },
      {
        title: "Balance Calculation",
        path: "billing/balance-calculation",
        file: "billing/balance-calculation.md",
      },
      {
        title: "Period and Proration",
        path: "billing/period-and-proration",
        file: "billing/period-and-proration.md",
      },
      {
        title: "Billing Minimums",
        path: "billing/billing-minimums",
        file: "billing/billing-minimums.md",
      },
      {
        title: "Fee Relocation and Splits",
        path: "billing/fee-relocation-and-splits",
        file: "billing/fee-relocation-and-splits.md",
      },
      {
        title: "Invoices",
        path: "billing/invoices",
        file: "billing/invoices.md",
      },
    ],
  },
  {
    title: "Integrations",
    pages: [{ title: "Schwab Integration", path: "schwab", file: "schwab.md" }],
  },
];

export function findDocByPath(path: string): DocPage | undefined {
  for (const section of docsManifest) {
    for (const page of section.pages) {
      if (page.path === path) return page;
      if (page.children) {
        for (const child of page.children) {
          if (child.path === path) return child;
        }
      }
    }
  }
  return undefined;
}
